function myFunction() {
   document.getElementById("myDropdown").classList.toggle("show1");
 }

 function CloseAllFunction() {
   var closeThisDropDown = document.getElementById("myDropdown");
   var closeThisDropDown2 = document.getElementById("myDropdown2");
   var closeThisDropDown3 = document.getElementById("myDropdown3");
   var closeThisDropDown4 = document.getElementById("myDropdown4");
   var closeThisDropDown5 = document.getElementById("myDropdown5");
   var closeThisDropDown6 = document.getElementById("myDropdown6");
   var closeThisDropDown7 = document.getElementById("myDropdown7");
   var closeThisDropDown8 = document.getElementById("myDropdown8");
   var closeThisDropDown9 = document.getElementById("myDropdown9");
   var closeThisDropDown10 = document.getElementById("myDropdown10");
   var closeThisDropDown11 = document.getElementById("myDropdown11");
   var closeThisDropDown12 = document.getElementById("myDropdown12");
   var closeThisDropDown13 = document.getElementById("myDropdown13");
   var closeThisDropDown14 = document.getElementById("myDropdown14");
   var closeThisDropDown15 = document.getElementById("myDropdown15");
   var closeThisDropDown16 = document.getElementById("myDropdown16");
   var closeThisDropDown17 = document.getElementById("myDropdown17");
   var closeThisDropDown18 = document.getElementById("myDropdown18");
   var closeThisDropDown19 = document.getElementById("myDropdown19");
   var closeThisDropDown20 = document.getElementById("myDropdown20");
   var closeThisDropDown21 = document.getElementById("myDropdown21");
   var closeThisDropDown22 = document.getElementById("myDropdown22");
   var closeThisDropDown23 = document.getElementById("myDropdown23");
   var closeThisDropDown24 = document.getElementById("myDropdown24");
   var closeThisDropDown25 = document.getElementById("myDropdown25");
   var closeThisDropDown26 = document.getElementById("myDropdown26");
   var closeThisDropDown27 = document.getElementById("myDropdown27");
   var closeThisDropDown28 = document.getElementById("myDropdown28");
   var closeThisDropDown29 = document.getElementById("myDropdown29");
   var closeThisDropDown30 = document.getElementById("myDropdown30");
   var closeThisDropDown31 = document.getElementById("myDropdown31");
   var closeThisDropDown32 = document.getElementById("myDropdown32");
   if (closeThisDropDown.classList.contains("show1")) {
     closeThisDropDown.classList.toggle("show1");
   } else if (closeThisDropDown2.classList.contains("show2")) {
     closeThisDropDown2.classList.toggle("show2");
   } else if (closeThisDropDown3.classList.contains("show3")) {
     closeThisDropDown3.classList.toggle("show3");
   }
   else
   if (closeThisDropDown4.classList.contains("show4")) 
   {
     closeThisDropDown4.classList.toggle("show4");
   }
   else
   if (closeThisDropDown5.classList.contains("show5")) 
   {
     closeThisDropDown5.classList.toggle("show5");
   }
   else
   if (closeThisDropDown6.classList.contains("show6")) 
   {
     closeThisDropDown6.classList.toggle("show6");
   }
   else
   if (closeThisDropDown7.classList.contains("show7")) 
   {
     closeThisDropDown7.classList.toggle("show7");
   }
   else
   if (closeThisDropDown8.classList.contains("show8")) 
   {
     closeThisDropDown8.classList.toggle("show8");
   }
   else
   if (closeThisDropDown9.classList.contains("show9")) 
   {
     closeThisDropDown9.classList.toggle("show9");
   }
   else
   if (closeThisDropDown10.classList.contains("show10")) 
   {
     closeThisDropDown10.classList.toggle("show10");
   }
   else
   if (closeThisDropDown11.classList.contains("show11")) 
   {
     closeThisDropDown11.classList.toggle("show11");
   }
   else
   if (closeThisDropDown12.classList.contains("show12")) 
   {
     closeThisDropDown12.classList.toggle("show12");
   }
   else
   if (closeThisDropDown13.classList.contains("show13")) 
   {
     closeThisDropDown13.classList.toggle("show13");
   }
   else
   if (closeThisDropDown14.classList.contains("show14")) 
   {
     closeThisDropDown14.classList.toggle("show14");
   }
   else
   if (closeThisDropDown15.classList.contains("show15")) 
   {
     closeThisDropDown15.classList.toggle("show15");
   }
   else
   if (closeThisDropDown16.classList.contains("show16")) 
   {
     closeThisDropDown16.classList.toggle("show16");
   }
   else
   if (closeThisDropDown17.classList.contains("show17")) 
   {
     closeThisDropDown17.classList.toggle("show17");
   }
   else
   if (closeThisDropDown18.classList.contains("show18")) 
   {
     closeThisDropDown18.classList.toggle("show18");
   }
   else
   if (closeThisDropDown19.classList.contains("show19")) 
   {
     closeThisDropDown19.classList.toggle("show19");
   }
   else
   if (closeThisDropDown20.classList.contains("show20")) 
   {
     closeThisDropDown20.classList.toggle("show20");
   }
   else
   if (closeThisDropDown21.classList.contains("show21")) 
   {
     closeThisDropDown21.classList.toggle("show21");
   }
   else
   if (closeThisDropDown22.classList.contains("show22")) 
   {
     closeThisDropDown22.classList.toggle("show22");
   }
   else
   if (closeThisDropDown23.classList.contains("show23")) 
   {
     closeThisDropDown23.classList.toggle("show23");
   }
   else
   if (closeThisDropDown24.classList.contains("show24")) 
   {
     closeThisDropDown24.classList.toggle("show24");
   }
   else
   if (closeThisDropDown25.classList.contains("show25")) 
   {
     closeThisDropDown25.classList.toggle("show25");
   }
   else
   if (closeThisDropDown26.classList.contains("show26")) 
   {
     closeThisDropDown26.classList.toggle("show26");
   }
   else
   if (closeThisDropDown27.classList.contains("show27")) 
   {
     closeThisDropDown27.classList.toggle("show27");
   }
   else
   if (closeThisDropDown28.classList.contains("show28")) 
   {
     closeThisDropDown28.classList.toggle("show28");
   }
   else
   if (closeThisDropDown29.classList.contains("show29")) 
   {
     closeThisDropDown29.classList.toggle("show29");
   }
   else
   if (closeThisDropDown30.classList.contains("show30")) 
   {
     closeThisDropDown30.classList.toggle("show30");
   }
   else
   if (closeThisDropDown31.classList.contains("show31")) 
   {
     closeThisDropDown31.classList.toggle("show31");
   }
   else
   if (closeThisDropDown32.classList.contains("show32")) 
   {
     closeThisDropDown32.classList.toggle("show32");
   }
 }

 /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
 function myFunction2() {
   document.getElementById("myDropdown2").classList.toggle("show2");
   document.getElementById("myDropdown").classList.toggle("show1");
 }

function myBackBtnFunc() 
{
  if (document.getElementById("myDropdown2").classList.contains("show2")) 
  {
    document.getElementById("myDropdown2").classList.toggle("show2");
    document.getElementById("myDropdown").classList.toggle("show1");
  } 
  else 
  if (document.getElementById("myDropdown4").classList.contains("show4")) 
  {
    document.getElementById("myDropdown4").classList.toggle("show4");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown5").classList.contains("show5")) 
  {
    document.getElementById("myDropdown5").classList.toggle("show5");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown6").classList.contains("show6")) 
  {
    document.getElementById("myDropdown6").classList.toggle("show6");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown7").classList.contains("show7")) 
  {
    document.getElementById("myDropdown7").classList.toggle("show7");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown8").classList.contains("show8")) 
  {
    document.getElementById("myDropdown8").classList.toggle("show8");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown9").classList.contains("show9")) 
  {
    document.getElementById("myDropdown9").classList.toggle("show9");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown10").classList.contains("show10")) 
  {
    document.getElementById("myDropdown10").classList.toggle("show10");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown11").classList.contains("show11")) 
  {
    document.getElementById("myDropdown11").classList.toggle("show11");
    document.getElementById("myDropdown").classList.toggle("show1");
  }
  else 
  if (document.getElementById("myDropdown12").classList.contains("show12")) 
  {
    document.getElementById("myDropdown12").classList.toggle("show12");
    document.getElementById("myDropdown2").classList.toggle("show2");
  }
  else 
  if (document.getElementById("myDropdown13").classList.contains("show13")) 
  {
    document.getElementById("myDropdown13").classList.toggle("show13");
    document.getElementById("myDropdown2").classList.toggle("show2");
  }
  else 
  if (document.getElementById("myDropdown14").classList.contains("show14")) 
  {
    document.getElementById("myDropdown14").classList.toggle("show14");
    document.getElementById("myDropdown2").classList.toggle("show2");
  }
  else 
  if (document.getElementById("myDropdown15").classList.contains("show15")) 
  {
    document.getElementById("myDropdown15").classList.toggle("show15");
    document.getElementById("myDropdown2").classList.toggle("show2");
  }
  else 
  if (document.getElementById("myDropdown16").classList.contains("show16")) 
  {
    document.getElementById("myDropdown16").classList.toggle("show16");
    document.getElementById("myDropdown4").classList.toggle("show4");
  }
  else 
  if (document.getElementById("myDropdown17").classList.contains("show17")) 
  {
    document.getElementById("myDropdown17").classList.toggle("show17");
    document.getElementById("myDropdown4").classList.toggle("show4");
  }
  else 
  if (document.getElementById("myDropdown18").classList.contains("show18")) 
  {
    document.getElementById("myDropdown18").classList.toggle("show18");
    document.getElementById("myDropdown4").classList.toggle("show4");
  }
  else 
  if (document.getElementById("myDropdown19").classList.contains("show19")) 
  {
    document.getElementById("myDropdown19").classList.toggle("show19");
    document.getElementById("myDropdown5").classList.toggle("show5");
  }
  else 
  if (document.getElementById("myDropdown20").classList.contains("show20")) 
  {
    document.getElementById("myDropdown20").classList.toggle("show20");
    document.getElementById("myDropdown19").classList.toggle("show19");
  }
  else 
  if (document.getElementById("myDropdown21").classList.contains("show21")) 
  {
    document.getElementById("myDropdown21").classList.toggle("show21");
    document.getElementById("myDropdown19").classList.toggle("show19");
  }
  else 
  if (document.getElementById("myDropdown22").classList.contains("show22")) 
  {
    document.getElementById("myDropdown22").classList.toggle("show22");
    document.getElementById("myDropdown19").classList.toggle("show19");
  }
  else 
  if (document.getElementById("myDropdown23").classList.contains("show23")) 
  {
    document.getElementById("myDropdown23").classList.toggle("show23");
    document.getElementById("myDropdown19").classList.toggle("show19");
  }
  else 
  if (document.getElementById("myDropdown24").classList.contains("show24")) 
  {
    document.getElementById("myDropdown24").classList.toggle("show24");
    document.getElementById("myDropdown5").classList.toggle("show5");
  }
  else 
  if (document.getElementById("myDropdown25").classList.contains("show25")) 
  {
    document.getElementById("myDropdown25").classList.toggle("show25");
    document.getElementById("myDropdown24").classList.toggle("show24");
  }
  else 
  if (document.getElementById("myDropdown26").classList.contains("show26")) 
  {
    document.getElementById("myDropdown26").classList.toggle("show26");
    document.getElementById("myDropdown24").classList.toggle("show24");
  }
  else 
  if (document.getElementById("myDropdown27").classList.contains("show27")) 
  {
    document.getElementById("myDropdown27").classList.toggle("show27");
    document.getElementById("myDropdown24").classList.toggle("show24");
  }
  else 
  if (document.getElementById("myDropdown28").classList.contains("show28")) 
  {
    document.getElementById("myDropdown28").classList.toggle("show28");
    document.getElementById("myDropdown24").classList.toggle("show24");
  }
  else
  if (document.getElementById("myDropdown29").classList.contains("show29")) 
  {
    document.getElementById("myDropdown29").classList.toggle("show29");
    document.getElementById("myDropdown8").classList.toggle("show8");
  }
  else
  if (document.getElementById("myDropdown30").classList.contains("show30")) 
  {
    document.getElementById("myDropdown30").classList.toggle("show30");
    document.getElementById("myDropdown9").classList.toggle("show9");
  }
  else
  if (document.getElementById("myDropdown31").classList.contains("show31")) 
  {
    document.getElementById("myDropdown31").classList.toggle("show31");
    document.getElementById("myDropdown10").classList.toggle("show10");
  }
  else
  if (document.getElementById("myDropdown32").classList.contains("show32")) 
  {
    document.getElementById("myDropdown32").classList.toggle("show32");
    document.getElementById("myDropdown11").classList.toggle("show11");
  }
}

 /* When the user clicks on the button,
toggle between hiding and showing the dropdown content */
 function myFunction3() {
   document.getElementById("myDropdown3").classList.toggle("show3");
   document.getElementById("myDropdown2").classList.toggle("show2");
 }

 function myBackBtnFunc2() {
   document.getElementById("myDropdown3").classList.toggle("show3");
   document.getElementById("myDropdown2").classList.toggle("show2");
 }

function myFunction4() 
{
  document.getElementById("myDropdown4").classList.toggle("show4");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction5() 
{
  document.getElementById("myDropdown5").classList.toggle("show5");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction6() 
{
  document.getElementById("myDropdown6").classList.toggle("show6");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction7() 
{
  document.getElementById("myDropdown7").classList.toggle("show7");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction8() 
{
  document.getElementById("myDropdown8").classList.toggle("show8");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction9() 
{
  document.getElementById("myDropdown9").classList.toggle("show9");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction10() 
{
  document.getElementById("myDropdown10").classList.toggle("show10");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction11() 
{
  document.getElementById("myDropdown11").classList.toggle("show11");
  document.getElementById("myDropdown").classList.toggle("show1");
}

function myFunction12() 
{
  document.getElementById("myDropdown12").classList.toggle("show12");
  document.getElementById("myDropdown2").classList.toggle("show2");
}

function myFunction13() 
{
  document.getElementById("myDropdown13").classList.toggle("show13");
  document.getElementById("myDropdown2").classList.toggle("show2");
}

function myFunction14() 
{
  document.getElementById("myDropdown14").classList.toggle("show14");
  document.getElementById("myDropdown2").classList.toggle("show2");
}

function myFunction15() 
{
  document.getElementById("myDropdown15").classList.toggle("show15");
  document.getElementById("myDropdown2").classList.toggle("show2");
}

function myFunction16() 
{
  document.getElementById("myDropdown16").classList.toggle("show16");
  document.getElementById("myDropdown4").classList.toggle("show4");
}

function myFunction17() 
{
  document.getElementById("myDropdown17").classList.toggle("show17");
  document.getElementById("myDropdown4").classList.toggle("show4");
}

function myFunction18() 
{
  document.getElementById("myDropdown18").classList.toggle("show18");
  document.getElementById("myDropdown4").classList.toggle("show4");
}

function myFunction19() 
{
  document.getElementById("myDropdown19").classList.toggle("show19");
  document.getElementById("myDropdown5").classList.toggle("show5");
}

function myFunction20() 
{
  document.getElementById("myDropdown20").classList.toggle("show20");
  document.getElementById("myDropdown19").classList.toggle("show19");
}

function myFunction21() 
{
  document.getElementById("myDropdown21").classList.toggle("show21");
  document.getElementById("myDropdown19").classList.toggle("show19");
}

function myFunction22() 
{
  document.getElementById("myDropdown22").classList.toggle("show22");
  document.getElementById("myDropdown19").classList.toggle("show19");
}

function myFunction23() 
{
  document.getElementById("myDropdown23").classList.toggle("show23");
  document.getElementById("myDropdown19").classList.toggle("show19");
}

function myFunction24() 
{
  document.getElementById("myDropdown24").classList.toggle("show24");
  document.getElementById("myDropdown5").classList.toggle("show5");
}

function myFunction25() 
{
  document.getElementById("myDropdown25").classList.toggle("show25");
  document.getElementById("myDropdown24").classList.toggle("show24");
}

function myFunction26() 
{
  document.getElementById("myDropdown26").classList.toggle("show26");
  document.getElementById("myDropdown24").classList.toggle("show24");
}

function myFunction27() 
{
  document.getElementById("myDropdown27").classList.toggle("show27");
  document.getElementById("myDropdown24").classList.toggle("show24");
}

function myFunction28() 
{
  document.getElementById("myDropdown28").classList.toggle("show28");
  document.getElementById("myDropdown24").classList.toggle("show24");
}

function myFunction29() 
{
  document.getElementById("myDropdown29").classList.toggle("show29");
  document.getElementById("myDropdown8").classList.toggle("show8");
}

function myFunction30() 
{
  document.getElementById("myDropdown30").classList.toggle("show30");
  document.getElementById("myDropdown9").classList.toggle("show9");
}

function myFunction31() 
{
  document.getElementById("myDropdown31").classList.toggle("show31");
  document.getElementById("myDropdown10").classList.toggle("show10");
}

function myFunction32() 
{
  document.getElementById("myDropdown32").classList.toggle("show32");
  document.getElementById("myDropdown11").classList.toggle("show11");
}

// function myFunction33()
// {
//   document.getElementById("myDropdown33").classList.toggle("show33");
// }

// function myFunction34()
// {
//   document.getElementById("myDropdown34").classList.toggle("show34");
// }

// function myFunction35()
// {
//   document.getElementById("myDropdown35").classList.toggle("show35");
// }

// Find all elements with the class 'closeDropdownX'
var elementsToReplace = document.querySelectorAll('.closeDropdownX');

// Iterate over each element and replace it with a new image
elementsToReplace.forEach(function (element) {
  // Create a new image element
  var newImage = document.createElement('img');
  newImage.src = 'https://cdn.shopify.com/s/files/1/0779/4281/7067/files/imageCloseButton.png?v=1689382291';
  newImage.style.width = '24px';
  newImage.style.height = '24px';
  newImage.className = 'closeDropdownX';
  newImage.onclick = CloseAllFunction;
  newImage.alt = 'Close';

  // Replace the element
  element.parentNode.replaceChild(newImage, element);
});
















